<!--
  PlatformFeeAllowanceWarning -- non-blocking store-editor notice (Jake,
  decision #8, 2026-10-07).

  On a store whose shopper bears the platform fee, checkout adds the fee to
  the shopper's total AFTER the allowance comes off, so an order the
  allowance covers in full still costs the shopper the fee -- charged to
  their card on a card store, included in the deduction on a payroll store
  (Bug Intake #481). That is how the money works, not an error; the
  distributor just needs to know.

  The backend decides the condition (``platform_fee.charged_despite_allowance``,
  the same rule checkout charges by) and the parent passes it in as ``show``.
  This component holds no rule of its own.
-->
<template>
  <p
    v-if="show"
    class="pfa-warning"
    role="note"
    data-testid="platform-fee-allowance-warning"
  >
    Shoppers will still pay the platform fee, even when their
    allowance covers the whole order. To cover it for them, choose
    "Distributor pays" for the platform fee.
  </p>
</template>

<script>
export default {
  name: "PlatformFeeAllowanceWarning",
  props: {
    show: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
/* Same notice treatment as the pricing grid's base-margin warning. */
.pfa-warning {
  margin: 0;
  padding: var(--tf-sp-2, 8px) var(--tf-sp-3, 12px);
  border: 1px solid #f5d491;
  background: #fffaf0;
  border-radius: var(--tf-radius-xs, 4px);
  font-size: 12px;
  color: #7a4b00;
}
</style>
